module.exports = __webpack_public_path__ + "static/08-ba9067d90e3d2f176c2ac627522e3e3e.jpg";